import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { SpaceOrderCollection } from '../index'

export const setupSpaceOrderReplication = (
  collection: SpaceOrderCollection,
  envId: string,
  currentUserId: string,
) =>
  createReplication({
    entityName: 'spaceorders',
    apiEntityName: 'spaceOrders',
    displayName: 'SpaceOrder',
    collection,
    envId,
    // Space ordering is private. The pull is already server-filtered to the
    // authenticated user and the broadcast is user-targeted; this is the
    // belt-and-braces guard on the shared workspace WS channel.
    documentFilter: (doc) => doc?.userId === currentUserId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      userId: doc.userId,
      projectId: doc.projectId,
      sortOrder: doc.sortOrder,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      userId: state.userId,
      projectId: state.projectId,
      sortOrder: state.sortOrder,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
